import React, { useContext } from "react";
import styled from "styled-components";
import {
    BusinessPortalHeader,
    Button,
    StandardModalDescription,
    StandardModalHeading,
    StandardModalSectionHeader
} from "src/components";
import { BodyAndMindContext } from "../BodyAndMindContext";
import PencilIcon from "src/img/edit@2x.png";

const UpperButton = styled(Button)`
    border-radius: 10px;
    height: 2.4375rem;
    width: 140px;
    color: white;
    background-color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;

    img {
        flex: 0 0 auto;
        margin-left: 0 !important;
    }
`;

const ModalHeaderWrap = styled.div`
    padding: 1.5rem 1.6rem 1.2rem;
    border-bottom: 1px solid #D8DEEC;
    box-sizing: border-box;
    margin-left: ${p => p.$flush ? "0" : "-3.5rem"};
    margin-right: ${p => p.$flush ? "0" : "-3.5rem"};
    width: ${p => p.$flush ? "100%" : "calc(100% + 7rem)"};

    @media (max-width: 640px) {
        margin-left: ${p => p.$flush ? "0" : "-1.25rem"};
        margin-right: ${p => p.$flush ? "0" : "-1.25rem"};
        width: ${p => p.$flush ? "100%" : "calc(100% + 2.5rem)"};
        padding: 1.25rem;
    }
`;

const ContentHeader = (props) => {
    const { title, titleStyle, description, includeChangeNameButton, children, flushModalHeader } = props;
    const { setShowChangeNameDialog } = useContext(BodyAndMindContext);

    if (titleStyle) {
        return (
            <ModalHeaderWrap $flush={flushModalHeader}>
                <StandardModalSectionHeader>
                    <div>
                        <StandardModalHeading>{title}</StandardModalHeading>
                        {description && (
                            <StandardModalDescription>
                                {description}
                            </StandardModalDescription>
                        )}
                    </div>
                    {children}
                </StandardModalSectionHeader>
            </ModalHeaderWrap>
        );
    }

    return (
        <BusinessPortalHeader
            title={title}
            description={description}
            maxWidth="98.625rem"
        >
            { includeChangeNameButton &&
                <UpperButton
                    backgroundColor="#000000"
                    onClick={() => setShowChangeNameDialog(true)}
                    style={{ margin: 0, borderRadius: 8 }}
                >
                                Change Name{" "}
                    <img
                        src={PencilIcon}
                        height="13px"
                        width="13px"
                    />
                </UpperButton>
            }
            {children}
        </BusinessPortalHeader>
    );
};

export default ContentHeader;
